<app-type-oui-non
  [uid]="getUid()"
  [parentForm]="parentForm"
  [label]="step4.getspan24"
  [disabled]="disabled"
  [value]="haveLot"
></app-type-oui-non>

<div *ngIf="isMarcheAlloti()">
<button class="btn btn-outline-primary" *ngIf="!disabled" (click)="addlot()">Ajouter un lot</button>
<div *ngFor="let obj of initial.lots.lot; let i = index">
  <button class="btn btn-outline-primary" *ngIf="!disabled" (click)="removelot(i)">Supprimer un lot</button>
  <app-lot
    [uid]="getUid() + '_index_' + (i + 1)"
    [parentForm]="parentForm"
    [i]="i"
    [disabled]="disabled"
    [lot]="obj"
    (prefEmit)="chargeDonneePreference($event)"
  ></app-lot>
</div>
</div>
